import { render, staticRenderFns } from "./PlanSubscription.vue?vue&type=template&id=94cd960a&"
import script from "./PlanSubscription.vue?vue&type=script&lang=js&"
export * from "./PlanSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports